import classNames from 'classnames'
import { Button } from 'components/atoms'
import i18n from 'i18n'
import React, { useCallback, useEffect, useState } from 'react'
import { Mention, MentionsInput, OnChangeHandlerFunc } from 'react-mentions'

import mentionClassNames from './mention-input.module.scss'
import { CommentTextBoxProps } from './model'
import { WrapperClass } from './styles'

const CommentTextbox = ({
  className,
  value,
  type = 'regular',
  permissions,
  onChange,
  onCommentSubmit,
  onCancel,
}: CommentTextBoxProps) => {
  const [textValue, setTextValue] = useState<string>('')

  const handleOnChange = useCallback<OnChangeHandlerFunc>(
    event => {
      const textValue = event.target.value || ''
      setTextValue(textValue)
      onChange && onChange(textValue)
    },
    [onChange]
  )

  useEffect(() => {
    setTextValue(value || '')
  }, [value])

  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement> | React.KeyboardEvent<HTMLInputElement>) => {
    const isCommandWithEnterHotKey = event.metaKey && event.keyCode === 13
    if (isCommandWithEnterHotKey) {
      handleCommentSubmit()
    }
  }

  const handleCommentSubmit = useCallback(() => {
    if (textValue.trim() !== '') {
      onCommentSubmit && onCommentSubmit(textValue.trim())
      setTimeout(() => {
        type === 'regular' && setTextValue('')
      }, 200)
    }
  }, [textValue, onCommentSubmit, type])

  const isBlankText = textValue.trim() === ''
  return (
    <div className={classNames(WrapperClass, className)}>
      <div className={`${permissions.isCreate ? 'comment-box-wrapper' : 'comment-box-wrapper disabled'}`}>
        <MentionsInput
          value={textValue}
          onChange={handleOnChange}
          onKeyDown={handleKeyDown}
          className="mentions"
          classNames={mentionClassNames}
          placeholder={i18n.t('components.AssetComment.comment_input_placeholder')}
          allowSuggestionsAboveCursor
          disabled={!permissions.isCreate}
        >
          <Mention
            markup="@[__display__](data:__id__)"
            trigger="@"
            data={[]} // parse empty array in order to not show mentions
            displayTransform={(id, display) => {
              return ` @${display} `
            }}
            appendSpaceOnAdd
            className={mentionClassNames.mentions__mention}
          />
        </MentionsInput>
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        {type === 'regular' && (
          <Button
            style={{ marginTop: 5 }}
            color="grey"
            disabled={isBlankText || !permissions.isEdit}
            showTooltipMessage={!permissions.isEdit ? i18n.t('common.actions.no_permission') : undefined}
            onClick={handleCommentSubmit}
          >
            {i18n.t('components.AssetComment.comment')}
          </Button>
        )}
      </div>
      {type === 'edit' && (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            className="cmt-textbox-cancel"
            style={{ marginTop: 5, marginRight: 5 }}
            color="grey"
            onClick={onCancel}
          >
            {i18n.t('common.actions.cancel')}
          </Button>
          <Button
            className="cmt-textbox-submit"
            style={{ marginTop: 5 }}
            disabled={isBlankText || !permissions.isEdit}
            showTooltipMessage={!permissions.isEdit ? i18n.t('common.actions.no_permission') : undefined}
            onClick={handleCommentSubmit}
          >
            {i18n.t('common.actions.save')}
          </Button>
        </div>
      )}
    </div>
  )
}

export default CommentTextbox
